import React, {useCallback, useMemo} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from "@mui/material";
import {Row} from "reactstrap";
import Button from "../../base/button/button";
import {exportCSVFile} from "../../../../core/services/utils/utils";
import useAccessLevels from "../../../hooks/use-access-levels";
import PartnerDataGrid, {DataGridColumnAlignments, DataGridColumnTypes} from "../../../containers/data-grid";
import ProductInformationPopover from "../../app-specific/draggable-popover/product-information-popover";

const DownloadAffectedProductsDialog = ({
                                            open,
                                            onClose,
                                            productList,
                                            message,
                                            fileTitle,
                                        }) => {

    const operatorAccessLevels = useAccessLevels();
    const canExportAffectedProducts = operatorAccessLevels.packages.lookup.exportAffectedProducts;

    /**
     * Downloads a csv file of the affected products.
     * @type {(function(): void)}
     */
    const downloadFile = useCallback(() => {
        if (!canExportAffectedProducts) {
            return;
        }
        const entries = productList?.map((partNo, i) => ({
            "": i + 1,
            "Part No": partNo,
        })) ?? [];
        exportCSVFile(entries, fileTitle ?? "Affected products");
        onClose();
    }, [canExportAffectedProducts, productList, fileTitle, onClose])

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            {
                title: "",
                name: "counter",
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
                resizable: false,
                width: 0,
            },
            {
                title: "Part No",
                name: "partNo",
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                sortable: false,
            },
        ], [])

    const dataGridRows = useMemo(() => productList
        ?.slice(0, 10)
        ?.map((partNo, i) => {
            return ({
                key: partNo,
                data: partNo,
                cells: {
                    'counter': i + 1,
                    'partNo':
                        <ProductInformationPopover partNo={partNo}>
                            {partNo ?? ''}
                        </ProductInformationPopover>,
                },
            });
        }) ?? [], [productList])

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle>
                    Affected Products
                </DialogTitle>
                <DialogContent>
                    <Typography variant={'body2'}>
                        {
                            message ??
                            "The following products are affected by your action, note that at most 10 of them are showed. " +
                            "you may download a csv file of these products for your reference."
                        }
                    </Typography>
                    <PartnerDataGrid
                        initialLayoutState={{columns: columns,}}
                        columns={columns}
                        rows={dataGridRows}
                        hideToolbar
                        hideFooter
                        visibleRows={5}
                    />
                </DialogContent>
                <DialogActions className={'p-0 m-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-between align-items-start w-100'>
                            <Button
                                disabled={!open}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={() => onClose()}
                                borderRadius={'0 10px 0 10px '}
                            >
                                Close
                            </Button>
                            <Button
                                disabled={!open || !canExportAffectedProducts}
                                variant={'dialog'}
                                color={'primary'}
                                onClick={() => downloadFile()}
                                borderRadius={'8px 0 8px 0'}
                            >
                                Download
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default DownloadAffectedProductsDialog;
